import { Card } from '@bancobarigui/barihaus';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { TopCity } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface TopCitiesChartProps {
  data: TopCity[];
  loading?: boolean;
  onBarClick?: (city: string, state: string) => void;
}

export function TopCitiesChart({ data, loading = false, onBarClick }: TopCitiesChartProps) {
  const chartData = {
    labels: data.map(item => `${item.name}-${item.state}`),
    datasets: [
      {
        label: 'Total de Vistorias',
        data: data.map(item => item.total),
        backgroundColor: '#52c41a',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    onClick: (_event: any, elements: any[]) => {
      if (elements.length > 0 && onBarClick) {
        const index = elements[0].index;
        const cityData = data[index];
        onBarClick(cityData.name, cityData.state);
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return `Total: ${context.parsed.x} vistorias`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title="Cidades com mais vistorias" bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '400px' }}>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
